import { render, staticRenderFns } from "./action.sidebar.vue?vue&type=template&id=53462c4f&scoped=true&"
import script from "./action.sidebar.vue?vue&type=script&lang=js&"
export * from "./action.sidebar.vue?vue&type=script&lang=js&"
import style0 from "./action.sidebar.vue?vue&type=style&index=0&id=53462c4f&prod&lang=scss&"
import style1 from "./action.sidebar.vue?vue&type=style&index=1&id=53462c4f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53462c4f",
  null
  
)

export default component.exports